import uly from "ulysses/core";
import $ from "jquery";
import ko from "knockout";
import HalResource from "ulysses/api";
import hex_md5 from "md5";
import blankfaceImage from "assets/mod-media/blankface.png";
import questionImage from "assets/mod-media/question.png";

ko.bindingHandlers.fileuploadbutton = {
    "init": function (element) {

        var $upload = $(element).next();
        var $elt = $(element);
        $upload.hover(function () {
            $elt.addClass("ui-state-hover");
        }, function () {
            $elt.removeClass("ui-state-hover");
        });
    }
};

var GRAVATARS = {
    "gabstract": "wavatar",
    "gmonsters": "monsterid",
    "mm": "mm",
    "retro": "retro",
    "monsterid": "monsterid",
    "identicon": "identicon",
    "blank": "blank"
};

ko.bindingHandlers.authimg = {
    update: function(elt, va, allbindings) {
        var url = ko.unwrap(va());
        var token = ko.unwrap(allbindings().token) || uly.api.token;
        if (url && (url.indexOf(uly.api.root) == 0 || url.indexOf("/") == 0) && token) {
            url += url.indexOf("?") >= 0 ? "&$token=" + token : "?$token=" + token;
        }
        $(elt).attr("src", url)
    }
};

ko.bindingHandlers.authlink = {
    update: function (elt, va, allbindings) {
        var url = ko.unwrap(va());
        var token = ko.unwrap(allbindings().token) || uly.api.token;
        if (url && (url.indexOf(uly.api.root) == 0 || url.indexOf("/") == 0) && token) {
            url += url.indexOf("?") >= 0 ? "&$token=" + token : "?$token=" + token;
        }
        console.log("authlink:", ko.dataFor(elt));
        $(elt).attr("href", url);
    }
};

ko.bindingHandlers.filelink = {
    update: function(elt, va, allbindings) {
        var trigger = ko.unwrap(va());
        setTimeout(function() {
            var token = ko.unwrap(allbindings().token) || uly.api.token;
            var href = $(elt).data("href");
            if (href && href.indexOf(uly.api.root) == 0 && token ) {
                href += href.indexOf("?") >= 0 ? "&$token="+token : "?$token=" + token;
            }
            $(elt).attr("href", href);
        },0);
    }
};

ko.bindingHandlers.fileupload = {
    "init": function (element, valueAccessor, bindings, viewModel, bindingContext) {

        var url = "/api/v2/media";
        var persistent = ko.unwrap(bindings().persistent);
        // if (persistent)
        //     url = "/mediafiles/upload";
        if (ko.utils.unwrapObservable(bindings().upload_uri)) {
            url = ko.utils.unwrapObservable(bindings().upload_uri);
            if (typeof url.href != "undefined")
                url = url.href;
        }


        var only_images = ko.unwrap(bindings().only_images);
        var check_existing = ko.unwrap(bindings().check_existing);
        var files = bindings().files;
        if (!files) files = ko.observableArray([]);
        function ColorLuminance(hex, lum) {

            // validate hex string
            hex = String(hex).replace(/[^0-9a-f]/gi, '');
            if (hex.length < 6) {
                hex = hex[0]+hex[0]+hex[1]+hex[1]+hex[2]+hex[2];
            }
            lum = lum || 0;
        
            // convert to decimal and change luminosity
            var rgb = "#", c, i;
            for (i = 0; i < 3; i++) {
                c = parseInt(hex.substr(i*2,2), 16);
                c = Math.round(Math.min(Math.max(0, c + (c * lum)), 255)).toString(16);
                rgb += ("00"+c).substr(c.length);
            }
        
            return rgb;
        }
        var init_file = function () {
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                $(element).removeClass("upload-drop").fileupload("destroy");
            });
            var tmpl = function tmpl(templateId, data) {
                var template = $("#" + templateId).html();
                var $tmp = $("#tmp");
                if (!$tmp || !$tmp.length) {
                    $tmp = $("<div id='tmp' style='display:none'></div>").appendTo($("body"));
                }
                ko.cleanNode($tmp);

                $tmp.html(template);

                ko.applyBindings(data, $tmp[0]);
                var newHtml = $tmp.html();
                ko.cleanNode($tmp);
                $tmp.remove();
                return $(newHtml);
            };
            var bgcolor = $(element).css("background-color");
            var fup = $(element).fileupload({
                url: url,
                dataType: "json",
                autoUpload: true,
                dropZone: $(element)
                .addClass("upload-drop")
                .on('drag dragstart dragend dragover dragenter dragleave drop', function(e) {
                    e.preventDefault();
                    e.stopPropagation();
                  })
                .on('dragover dragenter', function() {
                    $(element).css({
                        "background-color":"#DCDCDC"
                    });
                  })
                .on('dragleave dragend drop', function() {
                    
                    $(element).css({
                        "background-color":bgcolor
                    });
                  }),
                pasteZone: null,
                uploadTemplateId: null,
                downloadTemplateId: null,
                acceptFileTypes: only_images ? /(\.|\/)(gif|jpe?g|png)$/i : /.*/,
                formData: function () {
                    var uploads_id = ko.utils.unwrapObservable(valueAccessor());
                    var bound_entity = uly.utils.get_bound_entity($(element));
                    var uid = null;
                    if (bound_entity) {
                        uid = ko.unwrap(bound_entity.unique_id);
                    }
                    if (!uid && bindingContext.$data.__unique_id)
                        uid = ko.unwrap(bindingContext.$data.__unique_id);

                    if (Object.isObject(uploads_id) || Array.isArray(uploads_id) || !uploads_id) {
                        if (bound_entity && bound_entity.unique_id)
                            uploads_id = ko.unwrap(bound_entity.unique_id);
                        else if (uid)
                            uploads_id = uid;

                    }
                    var form_data = [{
                        "name": "current_id",
                        "value": uid
                    }, {
                        "name": "uploads_id",
                        "value": uploads_id
                    }, {
                        "name": "media_role",
                        "value": ko.unwrap(bindings().media_role)
                    }];
                    var force_no_list = ko.unwrap(bindings().no_list) || false;
                    if (force_no_list) {
                        form_data.push({
                            "name": "no_list",
                            "value": true
                        });
                    }

                    if (ko.unwrap(bindings().extra_data)) {
                        $.each(ko.unwrap(bindings().extra_data), function (key, value) {
                            var val = ko.toJS(value);
                            if (key && val) {
                                form_data.push({
                                    "name": key,
                                    "value": val
                                });
                            }
                            if (key == "note" && ko.isObservable(value))
                                value(null);
                        });
                    }
                    return form_data;
                },
                name: "__upload"
            }).bind("fileuploaddone", function (ev, fileupload) {
                if (fileupload.result && fileupload.result.id && fileupload.result.success && fileupload.result.postaction) {
                    //We have a single file. Do we need to execute the edit action?
                    var vals = uly.actions.get_$elt_and_ui(ev, {}, fileupload.result.postaction);
                    var $elt = vals[0];
                    var ui = vals[1];
                    ui.entity_model = { "id": fileupload.result.id, "unique_id": "Media#" + fileupload.result.id };
                    if (fileupload.result.postaction_id) {
                        ui.entity_model.id = fileupload.result.postaction_id;
                        ui.entity_model.unique_id = fileupload.result.postaction_unique_id || "Media#" + fileupload.result.postaction_id;
                    }

                    uly.actions.standard_action(ev, $elt, ui).then(function(res) {
                        uly.utils.show_results(fileupload.result);
                    });
                }
                //if (persistent)
                var res_files = [];
                if (fileupload.result && fileupload.result.files && Array.isArray(fileupload.result.files)) {
                    res_files = fileupload.result.files;
                    $.each(res_files, function (idx, file) {
                        var response = file.result;
                        var upload = $.extend({}, file, {
                            "title": ko.observable(file.name || file.filename),
                            "mimetype": file.type,
                            "role_id": ko.observable(file.role_id),
                            "role": {
                                "id": ko.observable(file.role? file.role.id : null),
                                "name": ko.observable(file.role ? file.role.name : null)
                            }
                        });
                        files.push(upload);
                        if (response) {
                            uly.utils.show_results(response);
                            if (response.epic_id) {
                                uly.dialogs.progress_epic(response.info, response.epic_id);

                            }
                        }
                    });
                } else {
                    if (fileupload.result && fileupload.result.success !== false) {
                        uly.utils.show_results(fileupload.result);
                        uly.publish("attachments.uploaded", {
                            "element": $(element),
                            "fup": fileupload,
                            "ev": ev
                        });
                        files.push(fileupload.result);
                        if (fileupload.result && fileupload.result.epic_id) {
                            uly.dialogs.progress_epic(fileupload.result.info, fileupload.result.epic_id);
                        }
                    } else {
                        uly.utils.show_results(fileupload.result);
                    }
                }
            });
        };

        setTimeout(function () {
            init_file();
        }, 0);
        var new_context = bindingContext.extend({
            "delete": function (ev, ui) {
                ev.preventDefault();

                console.error("Got deletion:", ev, ui);
                var model = ko.toJS(ui.model);
                if (model.deleteType && model.deleteType == "DELETE") {
                    HalResource(model).delete().done(function (result) {
                        files.splice(files.indexOf(ui.model), 1);
                        //uly.publish("attachments.deleted", { "element":$(ev.target), "ev":ev  });
                    }).fail(uly.utils.show_results);

                } else {
                    files.splice(files.indexOf(ui.model), 1);
                }
            }
        });

        ko.applyBindingsToDescendants(new_context, element);

        return {
            "controlsDescendantBindings": true
        };

    }
};
/*
 mediaupload: used for attachments list that upload to a screen's media list.
 */
ko.bindingHandlers.mediaupload = {
    "init": function (element, valueAccessor, bindings, viewModel, bindingContext) {
        var url = "/api/v2/media";
        var persistent = ko.unwrap(bindings().persistent);
        // if (persistent)
        //     url = "/mediafiles/upload";
        if (ko.unwrap(bindings().upload_uri))
            url = ko.unwrap(bindings().upload_uri);

        $(element).addClass("upload-drop").fileupload({
            url: url,
            dataType: "json",
            formData: function () {
                return [{
                    "name": "current_id",
                    "value": ko.unwrap(viewModel._currentEntityId)
                }, {
                    "name": "test",
                    "value": "test"
                }];
            },
            name: "__upload",
            done: function () {
                uly.publish("active_tabs:refresh", {
                    "page": viewModel
                });
            },
            fail: function () {}
        });
    }
};

ko.bindingHandlers.mediapic = {
    "update": function (element, va, allBindings, viewModel, context) {
        var media_info = ko.toJS(va());
        var pic = ko.utils.unwrapObservable(media_info.picture);
        var size = ko.utils.unwrapObservable(media_info.size);
        var fallback = ko.utils.unwrapObservable(media_info.fallback);
        var token = (pic ? ko.unwrap(pic.token) : ko.unwrap(media_info.token)) || uly.api.token;
        if (GRAVATARS[fallback]) {
            //need to ensure we are allowed to go near gravatar
            if (!uly.page.app_settings.allow_gravatars()) {
                fallback = "bface";
            }
        }
        var url = null;
        var $elt = $(element);
        if (pic && ko.utils.unwrapObservable(pic.href)) {
            url = pic.href;
            if (url && url.indexOf("/mediafiles") === 0)
                url = url.slice(1);

            if (url) {
                if (url.indexOf("mediafiles/") === 0) {
                    if (url.indexOf("mediafiles/pic/") === 0) {
                        url = uly.api.root + "/media/" + url.slice(15) + "?format=image";
                    } else {
                        url = uly.api_root + "/" + url + (url.indexOf("format=") === -1 ? "?format=image" : "");
                    }
                } else if (url.indexOf("/media/") === 0) {
                    url = uly.api.root + url + (url.indexOf("format=") === -1 ? "?format=image" : "");
                } else if ((url.indexOf(uly.api.root + "/media/") === 0) && (url.indexOf("format=") === -1)) {
                    url += "?format=image";
                }
            }
        } else if (pic && pic.typeof("String")) {
            url = pic;
            if ((url.indexOf(uly.api.root + "/media/") === 0) && (url.indexOf("format=") === -1))
                url += "?format=image";
        } else if (ko.utils.unwrapObservable(allBindings().mediapicsetter)) {
            url = uly.api.root + "/media/" + ko.utils.unwrapObservable(allBindings().mediapicsetter + "?format=image");
        }
        if (url && token) {
            if (url.indexOf("?") >= 0) {
                url += "&$token=" + token;
            } else {
                url += "?$token=" + token;
            }
        }
        var pixelsize = null;
        if (size == "thumbnail")
            pixelsize = 48;
        else if (size == "tiny")
            pixelsize = 64;
        else if (size == "small")
            pixelsize = 128;
        else if (size == "large")
            pixelsize = 512;
        else if (size == 0 || size == "*" || size == "native") {
            size = "";
            pixelsize = null;
        } else if (size) {
            if (typeof size == "string" && size.indexOf("nc") == size.length - 2) {
                pixelsize = 1 * size.slice(0, size.length - 2);
            } else {
                pixelsize = 1 * size;
                size = pixelsize;
            }

        } else size = null;

        if (!url) {
            if (fallback == "bface") {
                url = blankfaceImage;
            } else if (fallback == "question") {
                url = questionImage;
            } else if (GRAVATARS[fallback]) {
                var email = ko.utils.unwrapObservable(media_info.fallbackfield);
                if (null == email) {
                    email = "fallback@ulysses.qms-software.com";
                }
                var gsize = pixelsize || 64;
                if (email) {
                    email = email.replace(/^mailto:/, "").replace(/\?.*$/, "").toLowerCase();
                    url = [
                        "https://www.gravatar.com/avatar.php?gravatar_id=",
                        hex_md5(email),
                        "&d=" + (GRAVATARS[fallback]),
                        "&s=",
                        gsize
                    ].join("");
                }
            } else {
                $(element).unbind("click").hide();
                return;
            }
        } else {
            if (size) {
                if (url.indexOf("?") === -1)
                    url += "?";
                else url += "&";
                url = url + "size=" + size;
            }

        }
        if (url) {
            var $pic = null;
            var no_size = false;
            if (element.tagName == "IMG") {
                $pic = $elt;
                //no_size = true;
            } else
                $pic = $elt.children("img");

            if ($pic.length == 0)
                $pic = $("<img></img>").appendTo($elt);
            if ($pic.attr("src") != url) {
                $elt.show();
                $pic.attr("src", url);
                var status = ko.unwrap(media_info.status);
                if (status) $pic.addClass(status);
                else {
                    if ($elt.hasClass("online"))
                        $pic.addClass("online");
                    else
                        $pic.addClass("offline");
                }

                if (pixelsize && !no_size) {
                    //$elt.css("width",""+pixelsize+"px");
                    //$elt.css("height", ""+pixelsize+"px");
                    $pic.css("max-width", "" + pixelsize + "px");
                    $pic.css("max-height", "" + pixelsize + "px");
                } else {
                    $elt.css("width", null);
                    $elt.css("height", null);
                    $pic.css("max-width", null);
                    $pic.css("max-height", null);
                }

                if (pic)
                    $pic.attr("title", pic.title);
                //if ($pic.length)
                //    $pic.unwrap();

                if (Crimson && Crimson.view && Crimson.view.has_permissions(viewModel, context, "edit", va())) {
                    $elt.unbind("click").bind("click", function () {
                        var media_setter = allBindings().mediapicsetter;
                        if (typeof media_setter != "function")
                            return;
                        var current_entity = Crimson.view.get_current_entity(viewModel, context);
                        Crimson.dialogs.entity_gallery({
                            "unique_id": current_entity
                        }).done(function (result, dlg, buttons) {
                            if (buttons.button_clicked == "selectpic") {
                                var res = result.selected_data[0];
                                if (res) {
                                    media_setter(res.id);
                                } else {
                                    media_setter(null);
                                }
                            }
                        });
                    });
                } else {
                    $elt.unbind("click").bind("click", function () {
                        var media_setter = allBindings().mediapicsetter;
                        if (typeof media_setter != "function")
                            return;

                        if (ko.unwrap(viewModel.__unique_id))
                            var current_entity = ko.unwrap(viewModel.__unique_id);
                        else {
                            var current_entity = uly.utils.get_bound_entity(context);
                            if (current_entity) current_entity = ko.unwrap(current_entity.unique_id);
                            else current_entity = null;
                        }
                        uly.dialogs.show("entity_gallery", {
                            "unique_id": current_entity
                        }).then(function ([data, ui, button]) {
                            var image = ui.context.$parent.selected_data()[0];
                            if (image) {
                                media_setter(image.id);
                                var media_info = ko.unwrap(va());
                                if (media_info.picture) {
                                    if (ko.isObservable(media_info.picture.id))
                                        media_info.picture.id(image.id);
                                    else media_info.picture.id = ko.observable(image.id);
                                }

                            } else
                                media_setter(null);
                        }, ()=>{});
                    });
                }
            }
        } else if (!url) $(element).hide().unbind("click");
    },
};
ko.bindingHandlers.download = {
    update: function (elt, va, allBindings) {
        var media = ko.unwrap(va());
        var mimetype = ko.unwrap(media.mime_type);
        var title = ko.unwrap(media.title) || ko.unwrap(media.filename);
        var id = ko.unwrap(media.id);
        var url = ko.unwrap(ko.unwrap(media._links["uly:file"]).href);
        $(elt).data("contenttype", mimetype).attr("href", url).attr("title", title).attr("download", ko.unwrap(media.filename));
    }
};

ko.bindingHandlers.mediafile = {
    update: function (elt, va, allbindings) {
        var media = ko.unwrap(va());
        var linktype = ko.unwrap(allbindings().linktype) == "download" ? "download": "preview";
        var token = ko.unwrap(allbindings().token) || uly.api.token;
        if (media && (media.indexOf("http://") == 0 || media.indexOf("https://") == 0)) {
            if (media.indexOf(uly.api.root) == 0 && !media.indexOf("$token") && token) {
                media += (media.indexOf("?")  >= 0 ? "&" : "?") + "$token=" + token;
            }
            $(elt).attr("href", media);
            $(elt).attr("target", "blank");
        } else {
            media = uly.api.root + "/media/" + media + "/" + linktype;
            if ( token) {
                media += "?$token=" + token;
            }
            $(elt).attr("href", media);
            $(elt).attr("target", "blank");
        }
    }
};

$(document).unbind("action:deleteattachment").bind("action:deleteattachment", function (ev, ui) {
    ev.preventDefault();
    var viewModel = ko.contextFor(ev.target).$parent;
    HalResource(ko.toJS(ui.model)).delete().done(function (result) {
        uly.publish("attachments.deleted", {
            "element": $(ev.target),
            "ev": ev
        });
    }).fail(uly.utils.show_results);
});


window.dropZoneTimeout = [];
// $(document).bind("dragleave", function (e) {
//     window.dropZoneTimeout.push(setTimeout(function () {
//         $(".dragover").removeClass("dragover");
//     }, 500));
//     console.warn("dragleave");
// });
// $(document).bind("drop dragover", function (e) {

//     console.warn(e.type, e, $(this));
//     for (var i in window.dropZoneTimeout)
//         clearTimeout(window.dropZoneTimeout[i]);
//     $.each($(".upload-drop"), function () {
//         if (e.type == "drop") {
//             $(this).removeClass("dragover");
//         } else if (!$(this).hasClass("dragover")) {
//             $(this).addClass("dragover");
//         }
//     });

//     e.preventDefault();
// });
$(document).unbind("action:addmedia").bind("action:addmedia", function (ev, ui) {
    $(ev.target);
    $(document).bind("action:addmedia", function (ev, ui) {
        ev.preventDefault();
        $("#media-list-upload").click();
        return false;
    });

});
